import { useAdminServerUrl } from './store'

/**
 * Util is used for get server url in requests to api
 */
export const getServerUrl = () => {
	return useAdminServerUrl.getState().getCurrentServerUrl().url
}
